import { Injectable, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogueComponent } from "@app/core/services/alert/alert-dialogue-component";

export type AlertType = 'success' | 'warning' | 'error' | 'info';

export interface AlertSettings {
  overlay?: boolean | null;
  overlayClickToClose?: boolean | null;
  showCloseButton?: boolean | null;
  duration?: number | null;
}

@Injectable({
    providedIn: 'root'
})
export class AlertsService {

  private currentModalRef: any = null; // Track the current modal

  constructor(private modalService: NgbModal, private ngZone: NgZone) { }

  /**
   * 
   * @param type Alert type
   * @param message Message to display
   * @param settingsOverrides Optional settings to override default dialog
   * @param callBack Optional callback when alert dialog is closed
   */
  create(type: AlertType, message: string, settingsOverrides: AlertSettings = {}, callBack?: () => void, buttonText: string = "Close") {
    const displayDialogue = () => {
      if (this.currentModalRef) {
        this.currentModalRef.close();
        this.currentModalRef = null;
      }

      this.currentModalRef = this.modalService.open(AlertDialogueComponent, { centered: true, modalDialogClass: 'w-90 mx-auto' });
      const component = this.currentModalRef.componentInstance as AlertDialogueComponent;

      component.alertType = type;
      component.message = message;
      component.buttonText = buttonText;
      
      if (callBack) {
        this.currentModalRef.result.finally(() => {
          callBack();
        });
      }

      this.currentModalRef.result.finally(() => {
        this.currentModalRef = null;
      });
    };

    if (NgZone.isInAngularZone()) {
      displayDialogue();
    }
    else {
      this.ngZone.run(displayDialogue);
    }
  }

  linkify(message: string) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    if (urlRegex.test(message)) {
      return message.replace(urlRegex, function(url) {
        return `<a href="${url}" target="_blank">` + url + '</a>';
      });
    }

    return message;
  }
}
